module.exports = __webpack_public_path__ + "static/img/paypark.7032e1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/paypark.png
// module id = iN7m
// module chunks = 1